import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from 'react';
import styled, { css } from 'styled-components';
import { isValidSpacing, getSpacingValue, mapFlexAlignment } from '../utils';
import { breakpoint, map } from '../breakpoint';
import { mt, pl } from '../spacing';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ColumnsWrapper = styled(_ref => {
  let {
    space,
    collapseBelow,
    wrap,
    align,
    verticalAlign,
    reverse,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest
  });
}).attrs({
  'data-mesh-component': 'COLUMNS'
})`
  display: flex;
  flex-direction: row;

  ${_ref2 => {
  let {
    align
  } = _ref2;
  return align && map(align, val => val && css`
          justify-content: ${mapFlexAlignment(val)};
        `);
}}

  ${_ref3 => {
  let {
    verticalAlign
  } = _ref3;
  return verticalAlign && map(verticalAlign, val => val && css`
          align-items: ${mapFlexAlignment(val)};
        `);
}}

    ${_ref4 => {
  let {
    reverse
  } = _ref4;
  return map(reverse, val => val ? css`
            flex-direction: row-reverse;
          ` : css`
            flex-direction: row;
          `);
}}

    ${_ref5 => {
  let {
    wrap
  } = _ref5;
  return map(wrap, val => val ? css`
            flex-wrap: wrap;
          ` : css`
            flex-wrap: nowrap;
          `);
}}

  ${_ref6 => {
  let {
    collapseBelow
  } = _ref6;
  return collapseBelow ? css`
          /* When we are below the collapseBelow breakpoint: */
          ${breakpoint('xs', collapseBelow)`

          display: block;

      > * {
        width: 100%;
        
        &:not(:first-child) {
        ${_ref7 => {
    let {
      space
    } = _ref7;
    return map(space, val => isValidSpacing(val) && css`
                ${mt(val)};
              `);
  }};
        }
      }
    `};

          /* When we are above the collapseBelow breakpoint: */
          ${breakpoint(collapseBelow)`
      // Apply negative margin based on space prop
      ${_ref8 => {
    let {
      space
    } = _ref8;
    return map(space, val => isValidSpacing(val) && css`
              margin-inline-start: calc(0px - ${getSpacingValue(val)});
            `);
  }};

      // Apply padding based on space prop to children
      > * > * {
        ${_ref9 => {
    let {
      space
    } = _ref9;
    return map(space, val => isValidSpacing(val) && css`
                ${pl(val)};
              `);
  }};
      }
    `};
        ` : css`
          /* Apply negative margin based on space prop */
          ${_ref10 => {
    let {
      space
    } = _ref10;
    return map(space, val => isValidSpacing(val) && css`
                  margin-inline-start: calc(0px - ${getSpacingValue(val)});
                `);
  }};

          /* Apply margin based on space prop to children */

          > * > * {
            ${_ref11 => {
    let {
      space
    } = _ref11;
    return map(space, val => isValidSpacing(val) && css`
                    ${pl(val)};
                  `);
  }};
          }
        `;
}}
`;
export const Columns = _ref12 => {
  let {
    children,
    space = 0,
    reverse = false,
    wrap = false,
    align = 'left',
    verticalAlign = 'stretch',
    ...otherProps
  } = _ref12;
  return /*#__PURE__*/_jsx(ColumnsWrapper, {
    space: space,
    align: align,
    verticalAlign: verticalAlign,
    wrap: wrap,
    ...otherProps,
    reverse: reverse,
    children: Children.map(children, child => {
      if (/*#__PURE__*/isValidElement(child)) {
        return child;
      }
      return null;
    })
  });
};
Columns.displayName = 'Columns';